var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "modal-card",
      staticStyle: { width: "auto" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.add($event)
        }
      }
    },
    [
      _vm._m(0),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "BField",
            { attrs: { label: "Tipo de relación:" } },
            [
              _c(
                "BSelect",
                {
                  attrs: { placeholder: "Selecciona el tipo:", required: "" },
                  model: {
                    value: _vm.type,
                    callback: function($$v) {
                      _vm.type = $$v
                    },
                    expression: "type"
                  }
                },
                [
                  _c("option", { attrs: { value: "01" } }, [
                    _vm._v(
                      "\n          Nota de crédito de los documentos relacionados\n        "
                    )
                  ]),
                  _c("option", { attrs: { value: "03" } }, [
                    _vm._v(
                      "\n          Devolución de mercancía sobre facturas o traslados previos\n        "
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "BField",
            { attrs: { label: "Monto" } },
            [
              _c("BInput", {
                attrs: {
                  value: _vm.amount,
                  type: "number",
                  placeholder: "$0.00",
                  min: "1",
                  step: "0.01",
                  max: _vm.voucherTotal,
                  disabled: _vm.type === "03",
                  required: ""
                },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount"
                }
              })
            ],
            1
          ),
          _vm.type === "01"
            ? _c(
                "BField",
                { attrs: { label: "Porcentaje" } },
                [
                  _c("BInput", {
                    attrs: {
                      value: _vm.percentage,
                      type: "number",
                      placeholder: "1%",
                      min: "0",
                      max: "99",
                      required: ""
                    },
                    on: { input: _vm.onChangePercentage },
                    model: {
                      value: _vm.percentage,
                      callback: function($$v) {
                        _vm.percentage = $$v
                      },
                      expression: "percentage"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "button",
          {
            staticClass: "button",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$parent.close()
              }
            }
          },
          [_vm._v("\n      Cerrar\n    ")]
        ),
        _c("button", { staticClass: "button is-primary" }, [
          _vm._v("\n      Agregar\n    ")
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title has-text-centered" }, [
        _vm._v("\n      Selecciona Tipo y Monto\n    ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }